export default "__VITE_ASSET__H6ui6Vky__"